import React from 'react';
import { t } from '@lingui/core/macro';
import styled from 'styled-components';

import Select from '@rover/components/src/formFields/Select/Select';
import { SITTER_PROFILE_EVENTSTREAM_EVENTS } from '@rover/constants/src/translations/sitterProfilePage.constants';
import Dropdown from '@rover/icons/svg/dropdown-small.svg?url';
import { Flex } from '@rover/kibble/core';
import roverTheme from '@rover/kibble/themes/roverTheme';
import type { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';
import { Logger } from '@rover/rsdk/src/modules/Logging';
import emitMetric from '@rover/utilities/emitMetric';
import fireDataLayerEvent from '@rover/utilities/fireDataLayerEvent';

type Props = {
  selectedService: EnhancedPersonSitterProfileService;
  services: EnhancedPersonSitterProfileService[];
  onServiceChange?: (serviceSlug: string | undefined) => void;
  providerOpk: string;
};

export const StyledSelect: typeof Select = styled(Select)<{ theme: typeof roverTheme }>`
  select {
    padding: 12px 16px;
    height: initial;
    color: ${({ theme }) => theme.textColor.primary};
    font-size: ${({ theme }) => theme.text[200].fontSize};
    font-weight: ${({ theme }) => theme.text[200].fontWeight};
    line-height: ${({ theme }) => theme.text[200].lineHeight};
  }
` as unknown as typeof Select;

// eslint-disable-next-line rover/prefer-kibble-components
const SelectWrapper = styled.div`
  :after {
    content: '';
    background-image: url(${Dropdown});
    background-size: contain;
    position: absolute;
    pointer-events: none;
    top: 14px;
    right: 16px;
    width: 24px;
    height: 24px;
  }
  select {
    appearance: none;
  }
`;

const SimpleServiceSelector = ({
  selectedService,
  services,
  onServiceChange,
  providerOpk,
}: Props): JSX.Element => {
  const serviceOptions = [
    ...services.map((service) => ({
      title: service.displayName,
      value: service.slug,
    })),
  ];

  const handleServiceChange = (slug: string, component: string): void => {
    fireDataLayerEvent({
      event: SITTER_PROFILE_EVENTSTREAM_EVENTS.CHANGE_SERVICE,
      serviceType: slug,
      providerId: providerOpk,
    });
    emitMetric('sitter_profile_service_changed', { component });
    Logger.info('sitter_profile_service_changed', { component });
    if (onServiceChange) onServiceChange(slug);
  };

  return (
    <Flex flexDirection="column" width="100%" data-testid="service-selector" pb="6x">
      <SelectWrapper>
        <StyledSelect
          name="sevice-types-select"
          aria-label={t`Service selector`}
          options={serviceOptions}
          value={selectedService.slug}
          onChange={(svc: string) => {
            handleServiceChange(svc, 'selector');
          }}
          validationType="inline"
        />
      </SelectWrapper>
    </Flex>
  );
};
export default SimpleServiceSelector;
